<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-pc-detail-card">
    <v-row class="com-pc-card-header">
      <div class="com-pc-card-title">{{ text.obsInfo }} {{ appTime }}</div>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            dark
            small
            class="pl-2 refresh-icon-size"
            @click="renew"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        <span>{{ this.tooltipStr.refresh }}</span>
      </v-tooltip>
      <v-btn
        class="com-pc-card-button"
        @click="openMap()"
        max-height="20"
      >
        <v-icon>link</v-icon> {{ text.checkMap }}
      </v-btn>
    </v-row>
    <v-expansion-panels accordion class="tm-pc-detail-info-panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="pa-1 pr-4">
          <v-row no-gutters align="center" justify="start">
            <v-col md="auto" class="ma-2">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <img
                    src="/kawabou/img/obs_icons/obs_sea.svg"
                    class="tm-pc-detail-icon"
                    v-on="on"
                  />
                </template>
                <span>{{ text.obsType }}</span>
              </v-tooltip>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ tmCoastList.tmCoastDetailInfo.obsKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ tmCoastList.tmCoastDetailInfo.obsNm }}
              </div>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ tmCoastList.tmCoastDetailInfo.rsysKana }}{{ text.rsysKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ tmCoastList.tmCoastDetailInfo.rsysNm }}{{ text.rsys }}
              </div>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ tmCoastList.tmCoastDetailInfo.rvrKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ tmCoastList.tmCoastDetailInfo.rvrNm }}
              </div>
            </v-col>
            <div class="tm-pc-detail-frame-space"></div>

            <v-col class="pl-2">
              <!-- 観測値 -->
              <div class="tm-pc-detail-info-latest-value pb-1">
                <span>{{ text.obs_title }}</span>
                <span class="pl-2">{{ tmCoastList.curt.obsTime }}</span>
              </div>
              <div class="tm-pc-detail-border-line pt-1">
                <span
                  v-for="(item, index) in tmCoastList.curt.obs"
                  :key="`items-${index}`"
                >
                  <span class="tm-pc-detail-info-curt-title"
                    >{{ item.title }}:</span
                  >
                  <span class="tm-pc-detail-info-curt-value">{{
                    item.value
                  }}</span>
                  <span
                    class="tm-pc-detail-info-curt-unit"
                    v-html="item.unit"
                  ></span>
                  &nbsp;
                </span>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list dense>
            <!-- 観測所情報 -->
            <v-list-item
              v-for="(item, index) in tmCoastList.obsInfo"
              :key="`obs-${index}`"
              class="tm-pc-detail-info-list-item"
            >
              <v-row no-gutters>
                <v-col class="tm-pc-detail-info-list-title">{{
                  item.title
                }}</v-col>
                <v-col
                  v-if="showQwtrDbBtn(item.qwtrObsCd, item.dbLink)"
                  class="tm-pc-detail-info-list-value"
                >
                  <div>
                    <span
                      class="tm-pc-link"
                      @click="openQwtrDb(item.qwtrObsCd)"
                      >{{ item.obsValue }}</span
                    >
                  </div>
                </v-col>
                <v-col v-else class="tm-pc-detail-info-list-value">
                  <div>
                    <span style="line-break: strict">{{ item.value }}</span>
                    <span
                      class="tm-pc-detail-info-curt-unit"
                      v-html="item.unit"
                    ></span>
                  </div>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>

          <!-- 基準値(注意値/警戒値) -->
          <div class="tm-pc-detail-info-latest-value">
            {{ text.standard_title }}
          </div>
          <div class="tm-pc-detail-border-line">
            <span
              v-for="(item, index) in tmCoastList.standardValue"
              :key="`sd-${index}`"
            >
              <span class="tm-pc-detail-info-curt-title"
                >{{ item.title }}:</span
              >
              <span class="tm-pc-detail-info-curt-value">{{ item.value }}</span>
              <span
                class="tm-pc-detail-info-curt-unit"
                v-html="item.unit"
              ></span>
            </span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
import Util from "../../../lib/util";
import mixin from "./../../../lib/mixin.js";

/**
 * 川の防災情報 [PC]海岸 (詳細)観測所情報カード
 * TmCoastDetailInfo.vue
 * @author ILUKE
 */

export default {
  name: "tm-coast-detail-info",
  mixins: [mixin],
  data() {
    return {
      text: {
        obsInfo: "観測所情報",
        obsType: "海岸",
        obs_title: "■最新観測値",
        standard_title: "■基準値",
        rsys: "水系",
        rsysKana: "すいけい",
        checkMap: "地図で確認",
      },
    };
  },
  computed: {
    /**
     * 表示時刻
     */
    appTime: {
      get() {
        return Util.formatDate(this.$store.state.app.appTime);
      },
    },
    /**
     * 海岸情報 取得
     */
    tmCoastList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
  },
  methods: {
    showQwtrDbBtn(qwtrObsCd, dbLink) {
      if (qwtrObsCd !== null && qwtrObsCd !== undefined && dbLink === 1) {
        return true;
      } else {
        return false;
      }
    },
    openQwtrDb(qwtrObsCd) {
      let link =
        this.$store.state.app.config.appConfig.linkUrls.qwtrDbLink + qwtrObsCd;
      window.open(link);
    },
    /**
     * 更新クリックイベント
     */
    renew() {
      this.$log.debug("[TmObs] renew()");
      this.$store.commit("app/renewTime");

      // URLクエリ更新
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["isCurrent"] = true;
      delete setQuery["appTime"];
      delete setQuery["tmtime"];
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /** 同タブ内でマップ画面に遷移 */
    openMap() {
      let path = "/pc/tm";
      if (this.$store.state.map.zoom !== undefined) {
        this.routerPushTm(path);
      } else {
        this.routerOpenTm(path);
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
